import { IAction } from '@Root/types'

import {
  IUser,
} from '@SiteModules/User/types'

export const AuthenticationActionTypes = {
  SIGN_UP: '@@authentication/SIGN_UP',
  SIGN_UP_FAILURE: '@@authentication/SIGN_UP_FAILURE',
  SIGN_UP_SUCCESS: '@@authentication/SIGN_UP_SUCCESS',
  SIGN_IN: '@@authentication/SIGN_IN',
  SSO_SIGN_IN: '@@authentication/SSO_SIGN_IN',
  SIGN_IN_SUCCESS: '@@authentication/SIGN_IN_SUCCESS',
  SIGN_IN_FAILURE: '@@authentication/SIGN_IN_FAILURE',
  PASSWORD_NEW: '@@authentication/PASSWORD_NEW',
  PASSWORD_NEW_FAILURE: '@@authentication/PASSWORD_NEW_FAILURE',
  PASSWORD_NEW_SUCCESS: '@@authentication/PASSWORD_NEW_SUCCESS',
  UPDATE_PASSWORD: '@@authentication/UPDATE_PASSWORD',
  UPDATE_PASSWORD_FAILURE: '@@authentication/UPDATE_PASSWORD_FAILURE',
  UPDATE_PASSWORD_SUCCESS: '@@authentication/UPDATE_PASSWORD_SUCCESS',
  CREATE_OTP: '@@authentication/CREATE_OTP',
  CREATE_OTP_SUCCESS: '@@authentication/CREATE_OTP_SUCCESS',
  CREATE_OTP_FAILURE: '@@authentication/CREATE_OTP_FAILURE',
  VERIFY_OTP: '@@authentication/VERIFY_OTP',
  VERIFY_OTP_SUCCESS: '@@authentication/VERIFY_OTP_SUCCESS',
  VERIFY_OTP_FAILURE: '@@authentication/VERIFY_OTP_FAILURE',
}

export interface IAuthenticationState {
  readonly loading: boolean
}

export type Screen = 'signup' | 'signin' | 'forgot' | 'password'

export interface FormErrors {
  readonly email?: string
  readonly password?: string
  readonly confirmPassword?: string
  readonly emailOrDomain?: string
}

export interface ISignUpPayload {
  readonly email: string
  readonly password: string
  readonly passwordConfirmation: string
  readonly languages: string[]
}

export interface IIdentityBridgePayload {
  readonly anonymous_id?: string
  readonly session_id?: string
  readonly referrer_page?: string
  readonly original_referrer?: string
}

export interface ISignInPayload {
  readonly email: string
  readonly password: string
  readonly rememberMe: number
}

export interface IIdentityBridgeSignInPayload extends ISignInPayload, IIdentityBridgePayload {}

export interface IFullSignInPayload {
  readonly utf8: string
  readonly commit: string
  readonly user: IIdentityBridgeSignInPayload
}

export interface ISsoSignInPayload {
  readonly emailOrDomain: string
}

export type ISignInSuccessPayload = IUser

export interface IPasswordNewPayload {
  readonly email: string
}

export interface IFullPasswordNewPayload {
  readonly utf8: string
  readonly commit: string
  readonly user: IPasswordNewPayload
}

export interface IUpdatePasswordPayload {
  readonly password: string
  readonly passwordConfirmation: string
  readonly resetPasswordToken: string
}

export interface IFullUpdatePasswordPayload {
  readonly utf8: string
  readonly commit: string
  readonly user: IUpdatePasswordPayload
}

export interface ICreateOTPPayload {
  readonly shouldNotify?: boolean
}

export interface IVerifyOTPPayload {
  readonly otpCode: string
}

export type TAuthenticationActionTypes =
  IAction<ISignInSuccessPayload>
